/**
 * Gemeinsamer CKEditor für alle Rich-Text-Felder (Kommentare, Beschreibungen,
 * Positionen, Longform-Bausteine, Projektseiten).
 *
 * Seit v42 gibt es keine vorgebauten Builds mehr (@ckeditor/ckeditor5-build-classic
 * ist abgekündigt). Die Plugin-Liste entspricht dem alten Classic-Build ohne
 * Bild-, Medien- und Cloud-Plugins: Bilder hatten nie einen Upload-Adapter und
 * werden beim Anzeigen ohnehin entfernt (sanitizeHtml.js). Code (inline) ist
 * neu: Inhalte aus API/MCP nutzen <code>, der alte Build hat es beim
 * Bearbeiten gelöscht. Gegen alle Rich-Text-Inhalte von Prod geprüft (Round-Trip).
 */
// Direkt aus den Einzelpaketen statt aus dem Sammelpaket 'ckeditor5': dessen
// Einstieg re-exportiert alle ~60 Pakete, Webpack müsste die ganze Suite
// einlesen – das sprengt den Build-Speicher auf Prod (3,8 GB ohne Swap).
// Die Versionen müssen exakt zu ckeditor5 passen (package.json).
import { ClassicEditor as ClassicEditorBase } from '@ckeditor/ckeditor5-editor-classic';
import { Autoformat } from '@ckeditor/ckeditor5-autoformat';
import { BlockQuote } from '@ckeditor/ckeditor5-block-quote';
import { Bold, Code, Italic } from '@ckeditor/ckeditor5-basic-styles';
import { Essentials } from '@ckeditor/ckeditor5-essentials';
import { Heading } from '@ckeditor/ckeditor5-heading';
import { Indent } from '@ckeditor/ckeditor5-indent';
import { Link } from '@ckeditor/ckeditor5-link';
import { List } from '@ckeditor/ckeditor5-list';
import { Paragraph } from '@ckeditor/ckeditor5-paragraph';
import { PasteFromOffice } from '@ckeditor/ckeditor5-paste-from-office';
import { Table, TableToolbar } from '@ckeditor/ckeditor5-table';
import { TextTransformation } from '@ckeditor/ckeditor5-typing';
import translations from 'ckeditor5/translations/de.js';
import 'ckeditor5/ckeditor5.css';

export default class ClassicEditor extends ClassicEditorBase {
  // Ab v46 schreibt die Listen-Engine data-list-item-id an jedes <li>. Das
  // gespeicherte HTML (Suche, Mails, PDF-Bausteine) bleibt so wie vorher.
  getData(options = {}) {
    return super.getData({ skipListItemIds: true, ...options });
  }
}

ClassicEditor.builtinPlugins = [
  Autoformat, BlockQuote, Bold, Code, Essentials, Heading, Indent, Italic, Link, List,
  Paragraph, PasteFromOffice, Table, TableToolbar, TextTransformation,
];

ClassicEditor.defaultConfig = {
  licenseKey: 'GPL',
  language: 'de',
  translations: [translations],
  table: { contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'] },
  // Sonst landet class="ck-list-marker-bold" im gespeicherten HTML.
  list: { enableListItemMarkerFormatting: false },
};
